import {
  globalNavDrawerResizePlugin,
  readGlobalNavDrawerWidth,
  GLOBAL_NAV_DRAWER_DEFAULT_WIDTH
} from '@/ui/plugins/globalNavDrawerResizePlugin.js';

/**
 * CoreLeftDrawer·AdminPage 등 global-nav-drawer width 리사이즈 + IndexedDB 복원
 *
 * template: ref="globalNavDrawer" :width="globalNavDrawerWidth"
 */
export const globalNavDrawerResizeMixin = {
  data() {
    return {
      globalNavDrawerWidth: GLOBAL_NAV_DRAWER_DEFAULT_WIDTH
    };
  },

  watch: {
    drawer(isOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          this.initGlobalNavDrawerResize();
        });
      }
    }
  },

  methods: {
    async initGlobalNavDrawerResize() {
      const ref = this.$refs.globalNavDrawer;
      const el = ref?.$el ?? ref;
      if (!el) {
        return;
      }
      this.globalNavDrawerWidth = await readGlobalNavDrawerWidth();
      this.teardownGlobalNavDrawerResize();
      this._globalNavDrawerResizeCleanup = globalNavDrawerResizePlugin.attach(el, {
        getWidth: () => this.globalNavDrawerWidth,
        setWidth: width => {
          this.globalNavDrawerWidth = width;
        },
        onResize: () => {
          window.dispatchEvent(new Event('resize'));
        }
      });
    },

    teardownGlobalNavDrawerResize() {
      if (typeof this._globalNavDrawerResizeCleanup === 'function') {
        this._globalNavDrawerResizeCleanup();
        this._globalNavDrawerResizeCleanup = null;
      }
    }
  },

  beforeUnmount() {
    this.teardownGlobalNavDrawerResize();
  }
};
